<template>
  <div class="card">
    <div class="exhibitContent zhanpin">
      <div class="catalogue zhanpinl">
        <span @click="()=>{this.$router.back()}"><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/exhibit_back_en.png" alt=""/></span>
        <div class="catalogueTitle">
          <img :src="hrefurl+'/public/icon/zhanpin.png'" alt=""/>
          Product Categories
        </div>
        <CatalogueMain :sortData="sortData" @chooseSort="chooseSort"/>
      </div>
      <div class="query">
        <div class="exhibitRight" type="text">
          <div class="rightBtn">
            <div>
            </div>
            <div>
              <el-input placeholder="Search Product Categories" v-model="exhibitName" @change="productName"/>
              <el-button @click="productName">Search</el-button>
            </div>
          </div>
        </div>
        <div class="queryNav" style="display:none">
          <vueSeamless class="" :data="recommend" :class-option="defaultOption" >
            <ul class="liveList">
              <li v-for="(item,index) in recommend" :key="index">
                {{item.name}}
              </li>
            </ul>
          </vueSeamless>
        </div>
        <div class="queryList">
          <!-- 判断显示状态 -->
          <div v-if="tableData.listnum" class="queryGoods">
            <GoodsItem :class="(i+1)%4==0?'queryItem4':'queryItem'" v-for="(item,i) in tableData.list" :key="i" :item="item" :index="i" @isDetails="isDetails(item)" @modifyColl="modifyColl"/>
          </div>
          <div class="loadingNull" v-else>
            <div class="loading" v-if="loading">
              <div>
                <img :src="hrefurl+'/public/icon/loading.gif'" alt=""/>
              </div>
            </div>
            <div class="null" v-else>
              <div>
                <img :src="hrefurl+'/public/icon/without.png'" alt=""/>
              </div>
               No data is available!
            </div>
          </div>
        </div>
        <el-pagination
          v-if="tableData.listnum"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage1"
          :page-size="tableData.pagelistnum"
          layout="total, prev, pager, next"
          prev-text="prev"
          next-text="next"
          :total="tableData.listnum*1"
          >
        </el-pagination>
      </div>
    </div>
    <!-- 侧边联系方式 -->
    <!-- <div class="side">
      <img src="../../assets/kefu/qq.png" alt="qq"/>
      <img src="../../assets/kefu/weixin.png" alt="微信"/>
      <img src="../../assets/kefu/2.png" alt="电话"/>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import vueSeamless from 'vue-seamless-scroll'
import CatalogueMain from './catalogueMain'
import GoodsItem from "./goodsItem"
import {reqExhibitList, reqSortList} from '../../../api/index'
export default {
  components:{
    vueSeamless,
    CatalogueMain,
    GoodsItem
  },
  data(){
    return{
      exhibitName:'',//搜索
      // exhibitSort:'',//选择
      flag:0,  //排序
      tableData:{list:[],listnum:null,pagelistnum:0,thispage:0,islogin:0}, //数据右
      currentPage1: 1,//当前页
      sortData:[],  //展品分类列表
      SortContent:'',//展品分类选择
      loading:true,//加载中
      recommend:[
        {
          name:'推荐1',
        },
        {
          name:'推荐2',
        },
        {
          name:'推荐3',
        },
        {
          name:'推荐4',
        },
        {
          name:'推荐5',
        },
        {
          name:'推荐6',
        },
      ]
    }
  },
  methods:{
    handleCurrentChange(val) {//val:当前页
      this.exhibitList(val)
    },
    
    productName(){// 搜索
      this.exhibitList()
      this.currentPage1=1
    },
    
    demandSeek(index){// 排序---已停用
      this.flag=index
      this.exhibitList()
      this.currentPage1=1
    },

    async exhibitList(page=1){// 请求展品列表
      this.loading = true
      this.tableData = {
        islogin:0,
        list:[],
        listnum:0,
        pagelistnum:0,
        thispage:0
      }
      const response = await reqExhibitList(page,this.SortContent,this.exhibitName)
      if(response.code==0)
        this.tableData={
          islogin:response.islogin,
          list:response.resilt,
          listnum:response.listnum,
          pagelistnum:response.pagelistnum,
          thispage:response.thispage
        }
        else{
          this.tableData={
            islogin:0,
            list:[],
            listnum:0,
            pagelistnum:0,
            thispage:0
          }
          this.loading = false
        }
    },
    
    async sortList(){// 左侧列表请求
      const response = await reqSortList()
      if(response.code==0)
        this.sortData = response.resilt
    },
    
    chooseSort(data){// 子菜单
      this.SortContent = data.id
      // 1:搜索 2.页码
      this.exhibitList()
      this.currentPage1=1
    },

    isDetails(item){// 详情页跳转
      if (this.jump(this)){
        this.$router.push('/exhibit/details/'+item.id+'/'+item.ocid)
      }
      
    },

    modifyColl(index){//子页面取消收藏
      this.tableData.list[index].coll=this.tableData.list[index].coll==1?2:1
    }
  },
  computed:{
    ...mapState({
      isLogin:state=>state.user.isLogin,
    }),
    defaultOption () {
      return {
        // step: 1,
        direction: 2,
        hoverStop: true,
        openWatch: true,
      }
    }
  },
  mounted(){
    if (sessionStorage.getItem('goodsData')) {
      let goodsData = JSON.parse(sessionStorage.getItem('goodsData'))
      this.exhibitName = goodsData.product
      this.SortContent = goodsData.choose //分类选择
    }
    this.exhibitList()
    this.sortList()
    sessionStorage.removeItem('goodsData')
  }
}
</script>

<style scoped>
.card::before,
  .card::after{
    content: "";
    clear: both;
    display: block;
  }
  
  .card{
    max-width: 1200px;
    margin: 0 auto;
    box-shadow: none;
    background-color: transparent;
    border: none;
  }
  .exhibitContent{
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
  }
  .catalogue{
    max-width: 300px;
    width: 25%;
  }
  .catalogue>span{
    display: block;
    font-size: 26px;
    cursor: pointer;
    user-select: none;
    padding-top: 22px;
    padding-left: 10px;
    margin-bottom: 20px;
    width: 130px;
  }
  .catalogueTitle{
    width: 100%;
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    background-color: #008baf;
    padding-left: 24px;
    color: #fff;
    font-family: 'FjallaOne-Regular';
  }
  .catalogueTitle>img{
    width: 30px;
    vertical-align: middle;
  }
  
  .catalogue>>>.el-scrollbar__wrap{
    overflow: auto;
  }
  .catalogue>>>.el-scrollbar__bar.is-vertical{
    width: 20px;
    top: 0;
    right: 0;
    background: #e5e5e5;
    border-radius: 0;
  }
  .catalogue>>>.el-scrollbar__bar.is-vertical>div{
    width: 100%;
    background-color: #c1c1c1;
  }

  /* 右侧 */
  .query{
    max-width:900px;
    width: 75%;
    padding-top: 62px;
  }
  .exhibitRight, .exhibitRight>div{
    display: flex;
    justify-content: space-between;
  }
  .exhibitRight{
    margin-top: 36px;
    padding-bottom: 16px;
  }
  .exhibitRight>div{
    width: 100%;
  }
  .exhibitRight >>>.el-input{
    width: auto;
  }
  .exhibitRight >>> .el-button,
  .exhibitRight >>> .el-input__inner{
    border: none;
    border-radius: 0;
    vertical-align: bottom;
  }
  .rightBtn>div{
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #f08300;
  }
  .rightBtn>div:first-child{
    border: none;
  }
  .exhibitRight>div>>>input, .exhibitRight>div>>>select{
    width: 311px;
    height: 39px;
    font-size: 13px;
    padding: 0 14px;
    vertical-align: middle;
    border: 1px solid #dcdcdc;
  }
  .exhibitRight>div>>>button{
    width: 95px;
    height: 39px;
    padding: 0;
    vertical-align: middle;
    background-color: #f08300;
    border: 0;
  }
  .exhibitRight>>>button{
    color: #fff;
    font-size: 16px;
  }

  .queryNav{
    width: calc(100% - 18px);
    background-color: #fff;
    margin-bottom: 20px;
    margin-left: 18px;
    overflow: hidden;
    
  }
  .queryNav .liveList{
    white-space: nowrap;
  }
  .queryNav .liveList li{
    box-sizing: border-box;
    display: inline-block;
    width: 200px;
    height: 100%;
    padding: 10px;
    cursor: pointer;
  }
  .queryList{
    width: 100%;
  }
  .queryGoods{
    display: flex;
    flex-wrap: wrap;
  }
  .queryItem, .queryItem4{
    width: calc(25% - 18px);
    margin-bottom: 21px;
    background-color: #fff;
    margin-left: 18px;
  }
  /* 分页 */
  .query>>>.el-pagination{
    padding-top: 30px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .query>>>.el-dialog,
  .query>>>.el-pager li,
  .query>>>.el-pagination,
  .query>>>.el-pagination .btn-next,
  .query>>>.el-pagination .btn-prev,
  .query>>>.el-pagination button:disabled{
    background: none;
  }
  
  .loadingNull{
    width: 400px;
    text-align: center;
    margin: 140px auto;
    height: 100%;
  }
  .loading>div{
    width: 80px;
    margin: 180px auto;
  }
  .null>div{
    
    width: 200px;
    margin: 20px auto;
  }
  @media (min-width: 768px) and (max-width: 991.9px) {
    .queryItem, .queryItem4{
      width: calc(33.3% - 18px);
    }
  }
</style>